import notificationGlobal from '../../../Components/Global/NotificationGlobal'
import config from '../../../config'
import {
    OBTENER_ARCHIVOS_DOWNLOAD_DATA,
    REGISTER_USERS_CONNECTED_MODULES,
    DATA_DOWNLOAD_SELECTED,
    FILTERS_DOWNLOAD_DATA,
} from "../../../Constants/DownloadData/DownloadData"
import { RegisterAuditReducer } from "../Audits/Audits"
import { notification, Modal } from 'antd'
import { LoadingOutlined,CloudDownloadOutlined  } from '@ant-design/icons';

const notificacionServidor = (type, mensaje) => {
    if (type === 'success') {
        notification['success']({
            message: 'Éxito',
            description: mensaje,
        })
    } else if (type === 'warning') {
        notification['warning']({
            message: 'Advertencia',
            description: mensaje,
        })
    } else if (type === 'error') {
        notification['error']({
            message: 'Error',
            description: mensaje,
        })
    }
}

export const ObtenerArchivosDownloadDataReducer = () => async (dispatch, getState) => {

    const usuario = getState().loginGrow.rex_data_user_logingrow

    const data_download_file_get = {
        req_paiid: parseInt(localStorage.getItem("usupais"))
    }

    await fetch(config.api + 'data/get-download-data',
        {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                'usutoken': localStorage.getItem("usutoken"),
            },
            body: JSON.stringify(data_download_file_get),
        }
    )
        .then(async res => {
            return res.json()
        })
        .then(data => {
            if (data.response) {
                dispatch({
                    type: OBTENER_ARCHIVOS_DOWNLOAD_DATA,
                    payload: data.data
                })
            } else {
                // dispatch(RegisterAuditReducer('data/download-data', 'Error al obtener la data de los archivos', data.message, data_download_file_get, data, usuario.usuid, 'ip', 'GET DOWNLOAD DATA'))
            }
        }).catch((error) => {
            console.log(error)
        })
}
export const DownloadFileApiReducer = (data, date) => async (dispatch, getState) => {
  const spsa_cencosud = data.ardnombre == 'Arriendos Cencosud' ? 'descarga-arriendos-cencosud' : (data.ardnombre == 'Arriendos SPSA' ? 'descarga-arriendos-spsa' : 'descarga-arriendos-tottus');
  
  // Insertar estilo global para aumentar el z-index del modal y su fondo
  const styleElement = document.createElement('style');
  styleElement.type = 'text/css';
  styleElement.innerHTML = `
    .ant-modal-mask, .custom-download-modal {
      z-index: 9999 !important;
    }
    .ant-modal-wrap {
      z-index: 10000 !important;
    }
    @keyframes progress-animation {
      0% { margin-left: -30%; }
      100% { margin-left: 100%; }
    }
    .custom-download-modal .ant-modal-confirm-content {
      margin-top: 0 !important;
      margin-left: 0 !important;
      max-width: 100% !important;
    }
    .custom-download-modal .ant-modal-confirm-btns {
      display: none !important;
    }
    .custom-download-modal .ant-modal-confirm {
      padding-bottom: 0 !important;
    }
  `;
  document.head.appendChild(styleElement);
  
  // Mostrar modal de carga con diseño mejorado
  const loadingModal = Modal.info({
    title: null,
    className: 'custom-download-modal',
    content: (
      <div style={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '30px 20px',
        borderRadius: '8px',
        backgroundColor: '#f8fcff'
      }}>
        <div style={{ 
          backgroundColor: '#1890ff', 
          borderRadius: '50%', 
          width: '70px', 
          height: '70px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: '0 6px 16px rgba(24, 144, 255, 0.3)',
          marginBottom: '16px'
        }}>
          <CloudDownloadOutlined style={{ color: 'white', fontSize: '32px' }} spin />
        </div>
        <h3 style={{ 
          color: '#0d47a1', 
          fontSize: '18px', 
          fontWeight: 600,
          margin: '0 0 4px 0'
        }}>
          Descargando archivo
        </h3>
        <div style={{ 
          width: '100%', 
          maxWidth: '240px', 
          height: '4px', 
          backgroundColor: '#e6f7ff',
          borderRadius: '2px',
          overflow: 'hidden',
          marginTop: '20px'
        }}>
          <div 
            style={{ 
              width: '30%', 
              height: '100%', 
              backgroundColor: '#1890ff',
              borderRadius: '2px',
              animation: 'progress-animation 1.5s infinite ease-in-out',
            }} 
          />
        </div>
        <p style={{ 
          color: '#666', 
          marginTop: '16px',
          fontSize: '14px'
        }}>
          Procesando su solicitud, espere un momento...
        </p>
      </div>
    ),
    width: 360,
    maskClosable: false,
    closable: false,
    okButtonProps: { style: { display: 'none' } },
    icon: null,
    centered: true,
    zIndex: 10000, // Intentamos establecer un z-index alto en la configuración del modal
  });

  try {
    const response = await fetch(config.api_url + 'download/' + spsa_cencosud, {
      mode: 'cors',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-type': 'application/json',
        'usutoken': localStorage.getItem("usutoken"),
      },
      body: JSON.stringify({
        'fecha': date
      })
    });

    const result = await response.json();
    console.log('result', result);

    // Limpiar el estilo agregado
    document.head.removeChild(styleElement);
    
    // Cerrar el modal de carga
    loadingModal.destroy();

    if (result.response === false) {
      notification['warning']({
        message: 'Advertencia',
        description: result.messagge || 'No hay datos disponibles para la fecha seleccionada.',
        style: {
          borderLeft: '4px solid #faad14',
          backgroundColor: '#fffbe6'
        },
        placement: 'topRight',
        zIndex: 10001
      });
      return null;
    }

    // Notificación de éxito
    notification['success']({
      message: 'Descarga exitosa',
      description: 'El archivo se ha descargado correctamente.',
      style: {
        borderLeft: '4px solid #52c41a',
        backgroundColor: '#f6ffed'
      },
      placement: 'topRight',
      zIndex: 10001
    });

    // Iniciar la descarga del archivo
    if (result.url) {
      const link = document.createElement('a');
      link.href = result.url;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    return result.url;
  } catch (error) {
    console.log(error);
    
    // Limpiar el estilo agregado
    if (document.head.contains(styleElement)) {
      document.head.removeChild(styleElement);
    }
    
    // Cerrar el modal de carga en caso de error
    loadingModal.destroy();
    
    notification['error']({
      message: 'Error',
      description: 'Ocurrió un error al intentar descargar el archivo.',
      style: {
        borderLeft: '4px solid #ff4d4f',
        backgroundColor: '#fff2f0'
      },
      placement: 'topRight',
      zIndex: 10001
    });
  }
}
export const DownloadDataExcelReducer = (data) => async (dispatch, getState) => {

    const filtersDownloadData = getState().downloadData.rex_filters_download_data
    const filtersDownloadDataCopy = getState().downloadData.rex_filters_download_data_copy

    let req_filters = { req_id: data.ardid }

    let dataFilters = true
    filtersDownloadData.map(fil => {
        if (fil.show) {
            fil.data.map(typ => {
                if (typ.show) {
                    req_filters = { ...req_filters, [typ.filterName]: typ.value }
                } else {
                    dataFilters = false
                }
            })
        }
    })

    if (data.ardfiltros) {
        if (!dataFilters) {
            notificationGlobal("warning", "Es necesario seleccionar todos los filtros")
            return false
        }
    }

    let url = ""
    await fetch(config.api + 'download-data/download-url',
        {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                'usutoken': localStorage.getItem("usutoken"),
            },
            body: JSON.stringify(req_filters)
        }
    )
        .then(res => res.json())
        .then(async data => {
            if (data.response) {
                url = data.data
                dispatch({
                    type: FILTERS_DOWNLOAD_DATA,
                    payload: filtersDownloadDataCopy
                })
                notificacionServidor('success', data.message)
            } else {
                notificacionServidor('warning', data.message)
            }
        })
        .catch((error) => {
            console.log(error)
        })

    return url
}

export const CreateDownloadDataExcelReducer = () => async (dispatch, getState) => {
    const { rex_data_download_selected } = getState().downloadData

    let validation = true
    let respuesta = false

    if (rex_data_download_selected.usuid) {
        validation = false
    } else if (rex_data_download_selected.paiid) {
        validation = false
    } else if (rex_data_download_selected.pemid) {
        validation = false
    } else if (rex_data_download_selected.ardnombre) {
        validation = false
    } else if (rex_data_download_selected.ardarchivo) {
        validation = false
    } else if (rex_data_download_selected.ardcredenciales) {
        validation = false
    } else if (rex_data_download_selected.ardmostrar) {
        validation = false
    }

    if (validation) {
        await fetch(config.api + 'data/create-download-data',
            {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'usutoken': localStorage.getItem("usutoken"),
                },
                body: JSON.stringify({
                    data_download: rex_data_download_selected
                })
            }
        )
            .then(res => res.json())
            .then(async data => {
                if (data.response) {
                    notificacionServidor('success', data.message)
                    respuesta = true
                } else {
                    notificacionServidor('warning', data.message)
                }
            })
            .catch((error) => {
                console.log(error)
            })
    } else {
        notificacionServidor('warning', 'Por favor llenar todos los campos')
    }

    return respuesta
}

export const GetUniqueDownloadDataReducer = (id) => async (dispatch, getState) => {
    await fetch(config.api + 'data/get-unique-download-data',
        {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                'usutoken': localStorage.getItem("usutoken"),
            },
            body: JSON.stringify({
                req_id: parseInt(id),
            }),
        }
    )
        .then(res => res.json())
        .then(async data => {
            if (data.response) {
                dispatch({
                    type: DATA_DOWNLOAD_SELECTED,
                    payload: data.data
                })
            } else {
                notificacionServidor('warning', data.message)
            }
        }).catch((error) => {
            console.log(error)
        })
}

export const EditDownloadDataExcelReducer = (id) => async (dispatch, getState) => {
    const { rex_data_download_selected } = getState().downloadData

    let validation = true
    let respuesta = false

    if (rex_data_download_selected.usuid) {
        validation = false
    } else if (rex_data_download_selected.paiid) {
        validation = false
    } else if (rex_data_download_selected.pemid) {
        validation = false
    } else if (rex_data_download_selected.ardnombre) {
        validation = false
    } else if (rex_data_download_selected.ardarchivo) {
        validation = false
    } else if (rex_data_download_selected.ardcredenciales) {
        validation = false
    } else if (rex_data_download_selected.ardmostrar) {
        validation = false
    }

    if (validation) {
        await fetch(config.api + 'data/edit-download-data',
            {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'usutoken': localStorage.getItem("usutoken"),
                },
                body: JSON.stringify({
                    req_id: parseInt(id),
                    data_download: rex_data_download_selected,
                })
            }
        )
            .then(res => res.json())
            .then(async data => {
                if (data.response) {
                    notificacionServidor('success', data.message)
                    respuesta = true
                } else {
                    notificacionServidor('warning', data.message)
                }
            })
            .catch((error) => {
                console.log(error)
            })
    } else {
        notificacionServidor('warning', 'Por favor llenar todos los campos')
    }

    return respuesta
}

export const DeleteDownloadDataExcelReducer = (id) => async () => {
    let respuesta = false
    await fetch(config.api + 'data/delete-download-data',
        {
            mode: 'cors',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                'usutoken': localStorage.getItem("usutoken"),
            },
            body: JSON.stringify({
                req_id: parseInt(id),
            })
        }
    )
        .then(res => res.json())
        .then(async data => {
            if (data.response) {
                respuesta = true
                notificacionServidor('success', data.message)
            } else {
                notificacionServidor('warning', data.message)
            }
        })
        .catch((error) => {
            console.log(error)
        })

    return respuesta
}

export const ClearDownloadDataReducer = () => async (dispatch) => {
    dispatch({
        type: DATA_DOWNLOAD_SELECTED,
        payload: {}
    })
}

export const RegisterUsersConnectedModulesReducer = (data) => async (dispatch, getState) => {
    dispatch({
        type: REGISTER_USERS_CONNECTED_MODULES,
        payload: data
    })
}

export const SelectFilterDownloadDataReducer = (type, name, label) => async (dispatch, getState) => {

    const filtersDownloadData = getState().downloadData.rex_filters_download_data

    filtersDownloadData.map(dod => {

        //Fecha
        if (dod['name'] == type) {
            let indexFilter = dod['data'].findIndex(dat => dat.name == name)

            //Año-Mes
            if (label) {

                let itemFilter = dod['data'][indexFilter]['items'].find(lab => lab.label == label)
                if (dod['data'][indexFilter]['label'] == label) {
                    dod['data'][indexFilter]['value'] = null
                    dod['data'][indexFilter]['label'] = ""
                } else {
                    dod['data'][indexFilter]['value'] = itemFilter.value
                    dod['data'][indexFilter]['label'] = itemFilter.label
                }
            } else {
                dod['data'][indexFilter]['value'] = null
                dod['data'][indexFilter]['label'] = ""
            }

            let showFilter = dod['data'].some(item => item.value != null)

            dod['data'][indexFilter]['show'] = dod['data'][indexFilter]['value'] ? true : false
            dod['show'] = showFilter
        }
    })

    dispatch({
        type: FILTERS_DOWNLOAD_DATA,
        payload: filtersDownloadData
    })
}

export const ResetSelectFilterDownloadDataReducer = (type, name, label) => async (dispatch, getState) => {
    const filtersDownloadData = getState().downloadData.rex_filters_download_data

    filtersDownloadData.map(fil => {
        fil['show'] = false
        fil.data.map(dat => {
            dat['show'] = false
            dat['value'] = null
        })
    })

    dispatch({
        type: FILTERS_DOWNLOAD_DATA,
        payload: filtersDownloadData
    })
}